import {Component, Inject, TemplateRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

/**
 * GENERIC CONFIRMATION DIALOG
 */
@Component({
  selector: 'rn-confirmation-dialog',
  template: `
    <mat-dialog-content class="flex-col" [style.max-width]="data.maxWidth || '360px'">
      @if (data.title) {
        <h3>{{ data.title }}</h3>
      }
      <div class="flex-col">
        @if (data.warning) {
          <div class="warn-box dialog-warn-box flex-row flex-center-start">
            <span>{{ data.warning }}</span>
          </div>
        }
        <div class="dialog-body">
          @if (data.dialogBodyTemplateRef) {
            <ng-container *ngTemplateOutlet="data.dialogBodyTemplateRef; context: { data: data }"/>
          } @else {
            <span class="Text-Style">{{ data.message }}</span>
          }
        </div>
        <div class="dialog-button-row flex-row flex-center-center">
          @if (!data.hideCancel) {
            <button mat-stroked-button class="save-button-group button-cancel"
                    (click)="onNoClick()">
              {{ data.cancelButton || 'No' }}
            </button>
          }
          <button mat-raised-button color="primary" class="save-button-group save-button"
                  (click)="onSubmit()">
            {{ data.confirmButton || 'Yes' }}
          </button>
        </div>
      </div>
    </mat-dialog-content>
  `,
  styles: `
      .dialog-warn-box {
          padding: 5px;
      }
  `,
  standalone: false
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      warning: string;
      message: string;
      cancelButton: string;
      confirmButton: string;
      hideCancel: boolean;
      dialogBodyTemplateRef: TemplateRef<any>;
      maxWidth: string;
    }) {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    this.dialogRef.close(true);
  }
}
